module.exports = __webpack_public_path__ + "img/01.7a82ccc1.jpeg";